import {
  FetchFuelSurchargeFiltersParams,
  FetchOperationalExpensesParams,
  FetchTariffPricingTiersParams,
} from "../../../apis/drayage/types";
import { SortFilterDirectionsEnum } from "../../../types/drayage";

export enum TariffPricingTiersColumnNamesEnum {
  id = "id",
  name = "TariffPricingTierName",
  fscName = "FuelSurchargeProfileName",
  oeName = "OperationalExpensesProfileName",
}

export enum FuelSurchargeColumnNamesEnum {
  id = "id",
  name = "FscProfileName",
  doeRegionName = "DoeRegionName",
  calculatedFSC = "FscPercentage",
  fuelPrice = "FuelPricePerGallon",
}

export enum OperationExpensesColumnNamesEnum {
  id = "id",
  name = "operationalExpensesProfileName",
  milesPerGallon = "milesPerGallon",
  truckMonthlyPayment = "truckMonthlyPayment",
  truckMilesPerMonth = "truckMilesPerMonth",
  truckCostPerMile = "truckCostPerMile",
}

export const initialTPTParams: FetchTariffPricingTiersParams = {
  tariffPricingTierName: "",
  fuelSurchargeProfiles: [],
  operationalExpensesProfiles: [],
  pagination: {
    pageNumber: 1,
    pageSize: 512,
    includeTotalRecords: true,
  },
  sorting: {
    sortBy: TariffPricingTiersColumnNamesEnum.id,
    sortDirection: SortFilterDirectionsEnum.Ascending,
  },
};

export const initialFSCParams: FetchFuelSurchargeFiltersParams = {
  doeRegions: [],
  fscProfileName: "",
  pagination: {
    pageNumber: 1,
    pageSize: 512,
    includeTotalRecords: true,
  },
  sorting: {
    sortBy: FuelSurchargeColumnNamesEnum.name,
    sortDirection: SortFilterDirectionsEnum.Ascending,
  },
};

export const initialOEParams: FetchOperationalExpensesParams = {
  operationalExpensesProfileName: "",
  pagination: {
    pageNumber: 1,
    pageSize: 512,
    includeTotalRecords: true,
  },
  sorting: {
    sortBy: OperationExpensesColumnNamesEnum.name,
    sortDirection: SortFilterDirectionsEnum.Ascending,
  },
};
